import { useNavigate } from "react-router";
import { CTAWrapper } from "../CTA";
import { BUTTON_STYLES } from "../CTA/constants";

export const IconInfoCard = ({ cardType, imageUrl, imageAlt, headerText, content, footer, ctas, formattedSectionStyles, infoCardConfig=[], wrapperStyling, url }) => {
	const navigate = useNavigate();
	const link = url && cardType === "Link Card";
	return (
		<div
			onClick={() => link && navigate(url)}
			className={`flex flex-col ${formattedSectionStyles?.cardStyling?.backgroundColor} ${ctas ? "gap-[32px]" : "gap-4"} ${link && "cursor-pointer border border-transparent transition hover:border-is2-yellow-200"} rounded-[32px] w-full md:max-w-[550px] justify-between ${wrapperStyling || infoCardConfig[0]?.wrapperStyling || "p-10 md:p-8"}`}
		>
			<div className="flex flex-col gap-2 justify-between">
				{infoCardConfig[0]?.badge && <div className="bg-[#CCFCDA] px-2 rounded-sm w-fit font-bold text-is2-gray-450">NEW!</div>}
				<div className="flex flex-row justify-between">
					<h3 className={`font-bold text-left ${infoCardConfig[0]?.headerStyling || "text-is2-yellow-500 !text-lg"}`}>{headerText}</h3>
					{imageUrl && <img src={imageUrl} alt={imageAlt} className={`h-auto rounded-lg ${infoCardConfig[0]?.imageStyling || "w-[40px]"}`} />}
				</div>

				<div className={`${formattedSectionStyles?.cardStyling?.descriptionStyling} md:block !text-left [&>h4]:!text-is2_2xl [&>h4]:mb-0 [&>h5]:text-is2_lg [&>h5]:mb-2 [&>h5]:!mt-0 [&>div]:my-6 relative [&>ul>li]:mb-0 [&>ul]:list-none [&>ul>li]:before:absolute [&>ul>li]:before:left-0 [&>ul>li]:before:content-['✓'] [&>ul>li]:before:text-is2-green-650`}>{content}</div>
			</div>
			
				{ctas?.length>0 &&
					<div className="mt-auto">
						{ctas.map(cta => (
							<CTAWrapper
								key={cta.title}
								cta={{ ...cta, buttonStyling: [...cta.buttonStyling, BUTTON_STYLES.FULL_WIDTH] }}
							/>
						))}
					</div>
				}
		
			{footer && <span className={`[&>p]:!text-sm ${infoCardConfig[0]?.footerStyling ||""}`}>{footer}</span>}
		</div>
	);
};
